import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  headerRow: {
    '& *': {
      verticalAlign: 'middle',
    },
  },

  tableRow: {
    height: 52,
    '& a': {
      textDecoration: 'underline',
    },
  },

  selectedRow: {
    backgroundColor: theme.palette.type === 'dark' ? 'none' : '#f9f9f9',
  },

  sortIcon: {
    color: '#757575',
    transform: 'rotate(90deg)',
    marginRight: 6,
  },

  sortLabel: {
    fontSize: 14,
    color: '#757575',
  },

  sortSelect: {
    marginLeft: 8,
    '&:before': {
      borderBottom: 'none',
    },
  },

  countValue: {
    fontWeight: 500,
  },

  downloadButton: {
    display: 'flex',
    marginLeft: 'auto',
  },
}));

export default useStyles;
